module.exports = __webpack_public_path__ + "img/short_logo.b9a97a41.png";